import { useEffect } from 'react';

/**
 * Sets the document title to `${title} — Sentantia` on mount and whenever
 * the title changes. Intentionally does not restore the previous title on
 * unmount — the next page sets its own.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = `${title} — Sentantia`;
  }, [title]);
}
